"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Navigation = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _uxcore = require("@ux/uxcore2");

var _actions = require("../store/actions");

var _app = require("../store/reducers/app");

var _topics = require("../store/reducers/topics");

var _styles = _interopRequireDefault(require("../styles"));

var _Style = _interopRequireDefault(require("./Style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Navigation =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Navigation, _PureComponent);

  function Navigation(props) {
    var _this;

    _classCallCheck(this, Navigation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Navigation).call(this, props));
    _this.handleClickBack = _this.handleClickBack.bind(_assertThisInitialized(_this));
    _this.handleClickForward = _this.handleClickForward.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Navigation, [{
    key: "handleClickBack",
    value: function handleClickBack() {
      this.props.history.goBack();
      this.props.searchSuggestionsSetIndex(-1);
      this.props.trafficNavigationClick({
        type: 'back'
      });
    }
  }, {
    key: "handleClickForward",
    value: function handleClickForward() {
      this.props.history.goForward();
      this.props.searchSuggestionsSetIndex(-1);
      this.props.trafficNavigationClick({
        type: 'forward'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          appTopicId = _this$props.appTopicId,
          history = _this$props.history,
          location = _this$props.location,
          topics = _this$props.topics;
      var pathname = location.pathname;
      var isHome = pathname === '/';
      var isArticle = pathname.indexOf('/article') !== -1;
      var topicCurrent = topics && topics.find(function (topic) {
        return topic.id === appTopicId;
      });
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "help--navigation-container"
      }, _react.default.createElement("div", {
        className: "help--navigation-breadcrumb"
      }, !isHome && _react.default.createElement(_react.Fragment, null, _react.default.createElement(_reactRouterDom.Link, {
        to: '/',
        onClick: function onClick() {
          return _this2.props.trafficBreadcrumbClick({
            type: 'home'
          });
        }
      }, _react.default.createElement(_uxcore.Icon, {
        name: "home",
        size: 18,
        color: _styles.default.colors.tealMidrange
      })), isArticle && topicCurrent && _react.default.createElement(_react.Fragment, null, _react.default.createElement("span", null, "\xA0\xA0>\xA0\xA0"), _react.default.createElement(_reactRouterDom.Link, {
        to: "/topic/".concat(appTopicId),
        onClick: function onClick() {
          return _this2.props.trafficBreadcrumbClick({
            type: 'topic'
          });
        }
      }, topicCurrent.name)))), _react.default.createElement("div", {
        className: "help--navigation-back",
        onClick: this.handleClickBack,
        onKeyDown: null,
        role: "button",
        tabIndex: 0
      }, _react.default.createElement(_uxcore.Icon, {
        name: "chevron-left-lt",
        size: 14,
        color: history.canGo(-1) ? _styles.default.colors.black : _styles.default.colors.grayLight
      })), _react.default.createElement("div", {
        className: "help--navigation-forward",
        onClick: this.handleClickForward,
        onKeyDown: null,
        role: "button",
        tabIndex: 0
      }, _react.default.createElement(_uxcore.Icon, {
        name: "chevron-right-lt",
        size: 14,
        color: history.canGo(1) ? _styles.default.colors.black : _styles.default.colors.grayLight
      }))), _react.default.createElement(_Style.default, {
        css: "\n          .help--navigation-container {\n            background-color: ".concat(_styles.default.colors.white, ";\n            border-bottom: 1px solid ").concat(_styles.default.colors.grayFaint, ";\n            display: flex;\n            padding: 10px 1.5em;\n          }\n\n          .help--navigation-breadcrumb {\n            align-items: center;\n            color: ").concat(_styles.default.colors.gray, ";\n            display: flex;\n            flex: 1;\n            font-size: 0.9em;\n            line-height: 1.25;\n            padding-right: 10px;\n          }\n\n          .help--navigation-breadcrumb a {\n            align-items: center;\n            display: flex;\n            text-decoration: none;\n          }\n\n          .help--navigation-breadcrumb a span:hover {\n            color: ").concat(_styles.default.colors.teal, " !important;\n          }\n\n          .help--navigation-back, .help--navigation-forward {\n            align-items: center;\n            background-color: ").concat(_styles.default.colors.white, ";\n            border: 1px solid ").concat(_styles.default.colors.black, ";\n            cursor: pointer;\n            display: flex;\n            height: 25px;\n            justify-content: center;\n            outline: none;\n            width: 25px;\n          }\n\n          .help--navigation-back {\n            border: 1px solid ").concat(history.canGo(-1) ? _styles.default.colors.black : _styles.default.colors.grayLight, ";\n            margin-right: 5px;\n          }\n\n          .help--navigation-forward {\n            border: 1px solid ").concat(history.canGo(1) ? _styles.default.colors.black : _styles.default.colors.grayLight, ";\n          }\n        ")
      }));
    }
  }]);

  return Navigation;
}(_react.PureComponent);

exports.Navigation = Navigation;
Navigation.propTypes = {
  appTopicId: _app.appPropTypes.topicId,
  history: _propTypes.default.object.isRequired,
  location: _propTypes.default.object.isRequired,
  searchSuggestionsSetIndex: _propTypes.default.func.isRequired,
  topics: _topics.topicsPropType,
  trafficBreadcrumbClick: _propTypes.default.func.isRequired,
  trafficNavigationClick: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appTopicId: state.app.topicId,
    topics: Array.isArray(state.topics) ? state.topics : null
  };
};

var mapDispatchToProps = {
  searchSuggestionsSetIndex: _actions.searchSuggestionsSetIndex,
  trafficBreadcrumbClick: _actions.trafficBreadcrumbClick,
  trafficNavigationClick: _actions.trafficNavigationClick
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Navigation));

exports.default = _default;